export default __webpack_public_path__ + "static/media/mysql.f251faee.png";